// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdProductsSettingsResult = objectOf({
  info: nullOrUndefined,
  deleted_product_name: nullOrUndefined,
  warn: nullOrUndefined,
  warn_header: nullOrUndefined,
});
